export const createSpacingDiv = () => {
  const $element = document?.createElement('div');
  $element?.setAttribute('id', 'anchor-button-spacing');
  document?.body?.append($element);
};
